export default __webpack_public_path__ + "static/media/Rad-rabbit-rarity.a6f35f0c.png";